
export default function FloatingCTA() {
  const handleScheduleClick = () => {
    const widgetButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widgetButton) {
      widgetButton.click();
    }
  };

  return (
    <button
      onClick={handleScheduleClick}
      className="fixed bottom-8 right-28 z-40 bg-teal-600 text-white px-6 py-4 rounded-full shadow-2xl hover:bg-teal-700 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-semibold text-sm flex items-center space-x-2 group"
      aria-label="Schedule Now"
    >
      <i className="ri-calendar-line text-xl"></i>
      <span>SCHEDULE NOW</span>
    </button>
  );
}
